<div class="mb-progress-spinner">
  <mat-progress-spinner [diameter]="diameter" [mode]="mode" [color]="color" [strokeWidth]="strokeWidth" [value]="value">
  </mat-progress-spinner>
  <!-- <dx-load-indicator [height]="diameter" [width]="diameter"></dx-load-indicator> -->
</div>